<div class="add-user-container">
  <div class="header">
    <button mat-icon-button (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <h1>{{ isEditMode ? 'Edit User' : 'Add User' }}</h1>
  </div>

  <mat-card class="form-card">
    <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
      <div class="form-fields">
        <mat-form-field appearance="outline">
          <mat-label>Email</mat-label>
          <input matInput formControlName="email" placeholder="Enter email" type="email">
          @if (userForm.get('email')?.hasError('required')) {
            <mat-error>
              Email is required
            </mat-error>
          }
          @if (userForm.get('email')?.hasError('email')) {
            <mat-error>
              Please enter a valid email address
            </mat-error>
          }
        </mat-form-field>
      </div>

      <div class="form-actions">
        <button mat-button type="button" (click)="goBack()">Cancel</button>
        <button mat-raised-button color="primary" type="submit" [disabled]="userForm.invalid">
          {{ isEditMode ? 'Update' : 'Save' }}
        </button>
      </div>
    </form>
  </mat-card>
</div>
